import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { homeSliderMonth, topRatedDemo } from '../../../data/data';
import SuccessPopup from '../SuccessPopup';
import DemoContentItem from './DemoContentItem';
import DemoTopAnswerItem from './DemoTopAnswerItem';
import { categoriesMainData } from '../../../data/data';


export default function DemoTextInfo() {
    const searchFormData = useSelector((state) => state.searchFormData.value);
    const [showSuccess, setShowSuccess] = useState(false)

    // when open page if we save question show save success popup
    useEffect(() => {
        searchFormData.saveSearch &&
            setShowSuccess(true)
    }, [])
    useEffect(() => {
        // if open save success message hide it in 5s
        setTimeout(() => {
            showSuccess &&
                setShowSuccess(false)
        }, 5000);
    }, [showSuccess])


    return (
        <div>
            <SuccessPopup title="Success!" text="Your search was saved successfully!" showPopup={showSuccess} closePopup={() => setShowSuccess(false)} />
            <div className='font-firstFont mt-16 flex'>
                <div className='w-5/12 pr-11'>
                    <div className='mb-8'>
                        <div className='text-transparentWhite6 text-sm tracking-wider mb-2'>Question</div>
                        <div className='text-base font-medium'>
                            {
                                searchFormData.question ?
                                    categoriesMainData.filter(data => data.uniqueId === searchFormData.category).map((item) => (
                                        item.question.filter(questionData => questionData.uniqueId === searchFormData.question).map((info) => (
                                            info.item
                                        ))
                                    )) : ''
                            }
                        </div>

                    </div>
                    <div>
                        <div className='text-transparentWhite6 text-sm tracking-wider mb-2'>Finding</div>
                        <div className='text-base font-medium'>Most women learn about current events from local television news followed by internet, family and friends.</div>
                    </div>
                </div>
                <div className='w-7/12 pl-11'>
                    <div className='border border-mainColor p-6 rounded-[0.438rem] text-mainColor pr-11'>
                        <div className='text-sm tracking-wider mb-4'>Insight</div>
                        <div className='text-base font-semibold  '>Black Women Are Turining To Local TV News A Reliable Source For Information In Their Communitites. Local TV News Has Become Especially Imporatant During The Pandemic.</div>
                    </div>
                </div>
            </div>
            <div className='mt-7'>
                <div className='text-transparentWhite6 text-sm tracking-wider mb-2'>Content</div>
                <div className='flex flex-wrap gap-6'>
                    {
                        homeSliderMonth &&
                        homeSliderMonth.map((item, i) => (
                            <DemoContentItem data={item} key={item.id} itemIndex={`demoContentItem${i}`} />
                        ))
                    }
                </div>
            </div>
            <div className='mt-7'>
                <div className='text-transparentWhite6 text-sm tracking-wider mb-4'>Top answears aross all users</div>
                <div className='flex flex-wrap gap-6'>
                    {
                        topRatedDemo &&
                        topRatedDemo.map((item, i) => (
                            <DemoTopAnswerItem data={item} key={item.id} itemIndex={`demoTopAnswerItem${i}`} />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}
